import axios from 'axios';
import { req } from './axiosFun';


/**
 * 基础管理
 **/
//小程序用户
export const WxUserList = (params) => { return req("post", "/api/baseinfo/listWxuser", params) };
//用户权限等级 
export const WxAuthList = (params) => { return req("post", "/api/baseinfo/listWxAuth", params) };
//下拉用户
export const WxSelUser = (params) => { return req("post", "/api/baseinfo/selectUser", params) };
//下拉权限等级 
export const WxSelAuth = (params) => { return req("post", "/api/baseinfo/selectAuth", params) };
//新增-用户权限 
export const WxSaveUserAuth = (params) => { return req("post", "/api/baseinfo/saveUserAuth", params) };
//预览图类型，分页列表
export const WxThumTypeList = (params) => { return req("post", "/api/baseinfo/listThumType", params) };
//更新预览图类型
export const WxSaveThumType = (params) => { return req("post", "/api/baseinfo/saveThumType", params) };
//样式配置，分页列表
export const WxStyleConfList = (params) => { return req("post", "/api/baseinfo/listStyleConf", params) };
//样式配置，更新
export const WxSaveStyleConf = (params) => { return req("post", "/api/baseinfo/saveStyleConf", params) };

//下拉图片类型
export const WxSelTypes = (params) => { return req("post", "/api/baseinfo/selectTypes", params) };

/**
 * 系统管理 
 **/
// 用户列表
export const UserList = (params) => { return req("post", "/api/user/listUser", params) };
//更新用户信息
export const UsersSave = (params) => { return req("post", "/api/user/saveUsers", params) };
//删除用户
export const UsersDelete = (params) => { return req("post", "/api/user/usersDelete", {id:params}) };
//重置密码
export const PwdReset = (params) => { return req("post", "/api/user/usersPwdReset", {id:params}) };
//系统菜单，分页列表
export const MenusList = (params) => { return req("post", "/api/baseinfo/listMenus", params) };
//系统菜单，更新
export const MenusSave = (params) => { return req("post", "/api/baseinfo/saveMenus", params) };
//父级菜单，下拉
export const MenuParents = (params) => { return req("post", "/api/baseinfo/parentMenus", params) };


/**
 * 货道信息管理
 **/
// 货道信息管理-获取获取货道信息管理列表
export const MachineAisleList = (params) => { return req("post", "/api/MachineAisle/list", params) };
// 货道信息管理-删除货道信息管理
export const MachineAisleDelete = (params) => { return axios.delete("/api/MachineAisle/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 货道信息管理-保存货道信息管理
export const MachineAisleRsave = (params) => { return req("post", "/api/MachineAisle/save", params) };


// WEBPACK FOOTER //
// ./src/api/basisMG.js